import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ActivityInterface, WorkflowStepInterface } from '@vendasta/automata';
import { Observable } from 'rxjs';
import { SalesOrdersService } from '../../../../data-services/sales-orders.service';
import { ActivityTableEntry, AutomationDisplayService, NodeData } from '../../common/automation-display.service';

@Injectable({ providedIn: 'root' })
export class OrderLeasedToAutomationsService extends AutomationDisplayService {
  constructor(
    protected readonly translateService: TranslateService,
    protected readonly salesOrdersService: SalesOrdersService,
  ) {
    super();
  }

  /** Gets text for the activity column in the table. */
  getActivityColumn(_namespace: string, activity: ActivityInterface): ActivityTableEntry {
    const triggerData = activity?.triggerData ? JSON.parse(activity.triggerData) : {};

    const orderId = triggerData.order_id || '';
    const accountGroupId = triggerData.account_group_id || '';
    const orderLink = this.salesOrdersService.getOrderLink(orderId, accountGroupId);

    return this.tableEntry(
      this.translateService.stream('AUTOMATIONS.EDITOR.TRIGGERS.ENTERED_AUTOMATION'),
      this.translateService.stream('AUTOMATIONS.EDITOR.TRIGGERS.ORDER_LEASED_TO_AUTOMATIONS.ACTIVITY.LEASED', {
        orderLink: orderLink,
      }),
    );
  }

  /** The text in an automation node (i.e. the nodes in the graph). */
  getAutomationNodeData(
    _namespace: string,
    step: WorkflowStepInterface,
    _isWaitUntilNode: boolean,
  ): Observable<NodeData> {
    let textKey = 'AUTOMATIONS.EDITOR.TRIGGERS.ORDER_LEASED_TO_AUTOMATIONS.ACTION.WHEN_LEASED';
    if (step.waitForTriggerDefinitionId) {
      textKey = 'AUTOMATIONS.EDITOR.TRIGGERS.ORDER_LEASED_TO_AUTOMATIONS.ACTION.WAIT_UNTIL_LEASED';
    }

    return this.nodeDisplayData(this.translateService.stream(textKey), this.noValidationErrorsDetected());
  }
}
